import React from 'react'
import { Checkbox as CheckboxComponent, type CustomEventPayload, Events } from '../zaptic-checkbox'
import { createComponent, type EventName } from '@lit-labs/react'

export const Checkbox = createComponent(React, 'zaptic-checkbox', CheckboxComponent, {
    onChange: Events.onChange as EventName<CustomEvent<CustomEventPayload[Events.onChange]>>,
})
